<template>
  <a-modal v-model:visible="visible" title="添加坐诊机构" centered width="520px">
    <div>
      <a-form
        ref="formRef"
        :model="formState"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-item ref="name" label="机构名称：" name="hospitalId">
          <div class="select-area">
            <a-select
              v-model:value="formState.hospitalId"
              show-search
              :filter-option="false"
              :show-arrow="true"
              :default-active-first-option="false"
              placeholder="请选择机构"
              :options="hospitalList"
              allowClear
              @search="handleSearch"
              @focus="() => handleSearch('')"
              @popupScroll="handlePopupScroll"
            >
              <template #option="{ _name }">
                <div class="option">
                  <div class="item" v-html="_name"></div>
                </div>
              </template>
            </a-select>
          </div>
        </a-form-item>
        <a-form-item ref="simpleHospitalName" label="机构简称：" name="simpleHospitalName">
          <div class="input-area z-flex-c">
            <a-input
              v-model:value="formState.simpleHospitalName"
              placeholder="请输入机构简称"
              allowClear
              :maxlength="10"
            />
            <span class="num">{{ formState.simpleHospitalName?.length || 0 }}/10</span>
          </div>
        </a-form-item>
      </a-form>
    </div>
    <template #footer>
      <a-button key="back" @click="handleCancel">取消</a-button>
      <a-button key="submit" type="primary" @click="handleOk" :disabled="!formState.hospitalId">
        保存
      </a-button>
    </template>
  </a-modal>
</template>
<script setup>
import { ref, defineExpose, reactive, defineEmits } from 'vue'
import { addOutPatient, getHospitalListByPage } from '@/api/chat'
import { message } from 'ant-design-vue'
import { debounce } from 'lodash-es'
let ucDoctorId = ''
const emit = defineEmits(['updateHospital'])
const visible = ref(false)
const formRef = ref(null)
const formState = reactive({
  hospitalId: undefined,
  simpleHospitalName: ''
})
const rules = {
  hospitalId: [{ required: true, message: '请选择医院', trigger: 'blur', type: 'number' }]
}
const pageConfig = reactive({
  pageNo: 1,
  pageSize: 10,
  hasNext: true,
  keyword: ''
})
const hospitalList = ref([]) // 查询所有职业点
const historyList = ref([]) // 已经存在的职业点
// 点击提交
const handleOk = () => {
  formRef.value
    .validate()
    .then(() => {
      const { hospitalId } = formState
      if (historyList.value.find(item => item.hospitalId === hospitalId)) {
        message.error('该机构已存在')
        return
      }
      const params = {
        ...formState,
        ucDoctorId
      }
      addOutPatient(params).then(res => {
        message.success('操作成功！')
        emit('updateHospital', res || {})
        setTimeout(() => {
          visible.value = false
        }, 300)
      })
    })
    .catch(error => {
      console.log('error', error)
    })
}
const handleCancel = () => {
  visible.value = false
}
// 页面初始化
const initModal = params => {
  historyList.value = params.historyList || []
  visible.value = true
  hospitalList.value = []
  ucDoctorId = params?.ucDoctorId || ''
  formRef.value && formRef.value.resetFields()
}
const handleSearch = val => {
  pageConfig.pageNo = 1
  getHospitalList(val)
}
// 搜索机构
const getHospitalList = debounce(val => {
  const { pageNo, pageSize } = pageConfig
  if (val) {
    const query = {
      hospitalName: val,
      pageNo,
      pageSize
    }
    getHospitalListByPage(query)
      .then(data => {
        const list = data?.list || []
        pageConfig.hasNext = data?.hasNext || false
        if (data?.hasNext) {
          pageConfig.keyword = val
        }
        if (list?.length) {
          // 将结果中的机构名称中的搜索关键词进行高亮处理
          const regExp = new RegExp(val, 'g')
          const arr = list.map(item => {
            const { name, id } = item || {}
            item._name = name.replace(regExp, `<span style="color: #1890FF">${val}</span>`)
            item.value = id
            item.label = name
            return item
          })
          if (pageConfig.pageNo > 1) {
            hospitalList.value = hospitalList.value.concat(arr)
          } else {
            hospitalList.value = [...arr]
          }
        } else {
          hospitalList.value = []
        }
      })
      .catch(err => {
        hospitalList.value = []
      })
  } else {
    hospitalList.value = []
  }
}, 300)

// 滚动加载下一页
const handlePopupScroll = e => {
  const { scrollTop, scrollHeight, clientHeight } = e.target
  if (scrollTop + clientHeight >= scrollHeight - 2 && pageConfig.hasNext) {
    pageConfig.pageNo++
    getHospitalList(pageConfig.keyword)
  }
}
defineExpose({
  initModal
})
</script>
<style scoped lang="scss">
.select-area {
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #00000040;
  padding: 6px 12px;
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) {
    ::v-deep(.ant-select-selector) {
      border: none;
      box-shadow: none;
    }
  }
  ::v-deep(.ant-select-selector) {
    border: none;
  }
}
.input-area {
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #00000040;
  padding: 6px 12px;
  ::v-deep(.ant-input-affix-wrapper) {
    border: none;
    padding: none;
    &.ant-input-affix-wrapper-focused {
      outline: none;
      box-shadow: initial;
    }
  }
  .num {
    font-weight: 400;
    font-size: 14px;
    color: #00000040;
    margin-left: 6px;
  }
}
.option {
  padding: 11px 0;
  margin: 0 4px;
  border-bottom: 0.5px solid #efefef;

  .item {
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
  .address {
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 17px;
    margin-top: 4px;
  }
}
</style>
